// redux
import { useDispatch, useSelector } from "react-redux";
import {
    closeMapModal,
    setIncidentLocation
} from "services/redux/incidentForm/incidentForm";
import { AppDispatch, RootState } from "services/redux/store";

// UI
import { Button, SVG } from "ui";
import { useEffect, useState } from "react";
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";

import usePlacesAutocomplete, {
    getGeocode,
    getLatLng
} from "use-places-autocomplete";
import getAddressFromLatLng from "utils/helpers/getAddressFromLatLng";
import { LocationObj } from "services/redux/site/site";

export type Location = {
    lat: number;
    lng: number;
    address?: string;
};

export type SelectedLocation = Location & {
    address: string;
};

const containerStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "0.85rem"
};

const { REACT_APP_GOOGLE_API_KEY } = process.env;

const MapModal = () => {
    // redux
    const dispatch = useDispatch<AppDispatch>();
    const open = useSelector(
        (state: RootState) => state.incidentForm.openMapModal
    );
    const incidentLocation = useSelector(
        (state: RootState) => state.incidentForm.incidentLocation
    );

    const [selected, setSelected] = useState<LocationObj>(incidentLocation);
    const [center, setCenter] = useState<Location>(incidentLocation);
    const [marker, setMarker] = useState<Location>(incidentLocation);
    const [mapClicked, setMapClicked] = useState(false);
    const [intialClick, setIntialClick] = useState(false);
    useEffect(() => {
        if (!intialClick) {
            setCenter(incidentLocation);
            setMarker(incidentLocation);
        }
    }, [incidentLocation]);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: REACT_APP_GOOGLE_API_KEY || "",
        libraries: ["places"]
    });

    // ----------------------- marker
    const onLoadMarker = (marker: google.maps.Marker) => {
        console.log("marker: ", marker);
    };
    // handle click
    const handleMapClick = async (event: google.maps.MapMouseEvent) => {
        if (event.latLng) {
            const latLng = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            };
            try {
                const address = await getAddressFromLatLng(latLng);
                // setSearchVal(address);
                setMarker(latLng);
                !mapClicked && setMapClicked(true);
                setSelected({
                    ...latLng,
                    address
                });
            } catch (error) {
                console.error("Error geocoding location:", error);
            }
        }

        if (!mapClicked) {
            setMapClicked(true);
        }
    };

    useEffect(() => {
        setMarker({
            lat: selected?.lat as number,
            lng: selected?.lng as number
        });
        !mapClicked &&
            setCenter({
                lat: selected?.lat as number,
                lng: selected?.lng as number
            });
        setIntialClick(true);
    }, [selected]);

    const handleCloseMap = () => {
        dispatch(closeMapModal());
    };

    const handleSave = () => {
        dispatch(setIncidentLocation(selected));
        dispatch(closeMapModal());
    };

    useEffect(() => {
        // const [selected, setSelected] = useState<LocationObj>(incidentLocation);
        // const [center, setCenter] = useState<Location>(incidentLocation);
        // const [marker, setMarker] = useState<Location>(incidentLocation);
        // const [mapClicked, setMapClicked] = useState(false);
        // const [intialClick, setIntialClick] = useState(false);
        setSelected(incidentLocation);
        setCenter(incidentLocation);
        setMarker(incidentLocation);
        setMapClicked(false);
        setIntialClick(false);
    }, [open]);

    return (
        <div
            id="map-modal"
            className={`modal is-small has-light-bg ${open ? "is-active" : ""}`}
        >
            <div
                className="modal-background"
                style={{ background: "none" }}
                onClick={handleCloseMap}
            ></div>
            <div className="modal-content">
                <div className="card is-new-content">
                    <div className="card-heading flex-a-start">
                        {/* {{-- <div className="d-flex flex-j-start flex-a-start gap-5 flex-col"> --}} */}
                        <p className="momeento-p">Choose Location</p>

                        {/* {{-- </div> --}} */}

                        {/* <!-- Close X button --> */}
                        <div className="close-wrap">
                            <span
                                className="close-modal"
                                onClick={handleCloseMap}
                            >
                                <SVG svg="x" size={16} />
                            </span>
                        </div>
                    </div>
                    {!isLoaded ? (
                        <p className="momeento-p">Loading Map</p>
                    ) : (
                        <>
                            <div className="card-heading flex-a-start flex-col gap-10">
                                <PlacesAutocomplete
                                    setSelected={setSelected}
                                    mapClicked={mapClicked}
                                    setMapClicked={setMapClicked}
                                />

                                <div className="momeento-p d-flex flex-j-start gap-5">
                                    <SVG
                                        svg="map-pointer"
                                        size={18}
                                        className="red-svg"
                                    />{" "}
                                    <span>{selected?.address}</span>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="control">
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "500px"
                                        }}
                                        className="p-relative"
                                    >
                                        <GoogleMap
                                            mapContainerStyle={containerStyle}
                                            center={center}
                                            zoom={12}
                                            onClick={handleMapClick}
                                        >
                                            {/* marker */}
                                            <MarkerF
                                                onLoad={onLoadMarker}
                                                position={marker}
                                            />
                                        </GoogleMap>
                                    </div>
                                </div>
                            </div>

                            <div className="card-footer d-flex flex-j-end pt-10">
                                <Button text="Save" handleClick={handleSave} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export type PlacesAutocompleteProps = {
    setSelected: React.Dispatch<React.SetStateAction<LocationObj>>;
    mapClicked?: boolean;
    setMapClicked?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PlacesAutocomplete: React.FC<PlacesAutocompleteProps> = ({
    setSelected,
    mapClicked,
    setMapClicked
}) => {
    const {
        value,
        setValue,
        suggestions: { status, data },
        clearSuggestions
    } = usePlacesAutocomplete();

    const [showItems, setShowItems] = useState(false);

    const handleSelect = async (address: string) => {
        setValue("", false);
        setShowItems(false);
        clearSuggestions();

        const results = await getGeocode({ address });
        const { lat, lng } = await getLatLng(results[0]);
        mapClicked && setMapClicked && setMapClicked(false);
        setSelected({ lat, lng, address });
    };

    useEffect(() => {
        setShowItems(true);
    }, [data]);

    return (
        <div className={`field w-full`}>
            <div
                className="control has-icon p-relative map-auto-complete-container"
                // ${loading ? "is-loading" : ""}
            >
                <input
                    id={"search-box"}
                    type="text"
                    className="input  is-rounded"
                    onChange={(e) => setValue(e.target.value)}
                    value={value}
                    placeholder={"Search for place..."}
                />
                <div className="form-icon">
                    <SVG svg={"search"} size={16} />
                </div>
                <div
                    className={`items-container ${showItems && data.length ? "show" : ""}`}
                >
                    <ul>
                        {status === "OK" &&
                            data.map(({ place_id, description }) => (
                                <li
                                    key={place_id}
                                    onClick={() => handleSelect(description)}
                                >
                                    {description}
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MapModal;
